/** @jsx h */

import Preact, { h } from 'preact'
import Question from './Question'
import { styleguide } from 'styleguide'
import { delay, hash } from './utils'
import questions from './sampleQuestions'

const defaultTheme = {
  brand: styleguide.colors.secondary,
  titleFont: 'Georgia, Times New Roman, serif',
  titleWeight: 'bold',
}

const tempQuestion = questions[0]

function randomQuestion() {
  return questions[Math.floor(Math.random() * questions.length)]
}

const fragment = (q, left, top, width) =>
  `<div id="scoops-${q}" style="z-index: 9999999999999; position: relative; max-height: 0; overflow: visible; top: ${top}px; left: ${left}px; width: ${width}px"/></div>`

function makeTrack(mp, meta) {
  if (mp && typeof mp === 'object' && typeof mp.track === 'function') {
    return (event, data) =>
      mp.track(event, {
        ...meta,
        ...data,
      })
  }
}

function serve({
  event,
  eventHash,
  selector,
  question,
  theme,
  resolve,
  track,
  offset,
  onRemove,
}) {
  const target = document.getElementById(selector ? selector : event)
  const body = document.getElementsByTagName('body')[0]

  const { y, x } = target.getBoundingClientRect()
  const offsetScroll = window.pageYOffset

  const width =
    window.innerWidth > 450 + 40 * 2 ? 450 : window.innerWidth - 40 * 2
  const align = window.innerWidth - x > width ? 'left' : 'right'
  return delay(1).then(() => {
    body.insertAdjacentHTML(
      'afterbegin',
      fragment(eventHash, x, y + offsetScroll, target.clientWidth)
    )

    return Preact.render(
      <Question
        event={event}
        align={align}
        question={question}
        targetY={y}
        offset={offset}
        targetHeight={target.clientHeight}
        theme={theme}
        surveyWidth={width}
        track={track}
        onRemove={() =>
          onRemove(resolve, document.getElementById(`scoops-${eventHash}`))
        }
      />,
      document.getElementById(`scoops-${eventHash}`)
    )
  })
}

export default function(key, mixpanel, appTheme) {
  const theme = {
    ...defaultTheme,
    ...appTheme,
  }

  const service = {
    eventList: [],
    openEvent: undefined,
    updateEventList(event) {
      service.eventList.push(event)
    },
    updateOpenEvent(event) {
      service.openEvent = event
    },
    onRemove(resolve, scoops) {
      service.updateOpenEvent(undefined)
      scoops && scoops.parentNode && scoops.parentNode.removeChild(scoops)
      return resolve()
    },
    survey(event, selector, { offset, cycle } = {}) {
      return new Promise((resolve, reject) => {
        const eventHash = hash(event)
        if (service.openEvent === eventHash) return
        if (!cycle && service.eventList.includes(eventHash)) {
          return reject('already called')
        }

        if (service.openEvent && service.openEvent !== event) {
          service.onRemove(() => {},
          document.getElementById(`scoops-${service.openEvent}`))
        }

        const track = makeTrack(mixpanel, {
          Question: tempQuestion.title,
          Event: event,
          Answers: tempQuestion.answers.map(a => a.text),
          'Previous Surveys': service.eventList,
        })

        service.updateOpenEvent(eventHash)
        service.updateEventList(eventHash)

        return serve({
          event,
          eventHash,
          selector,
          question: !cycle ? tempQuestion : randomQuestion(),
          theme,
          resolve,
          track,
          offset,
          onRemove: service.onRemove,
        })
      })
    },
  }

  return service
}



// WEBPACK FOOTER //
// ../api/src/api.js